export default __webpack_public_path__ + "static/media/cloudcommerce-logo.2778bd52.png";